import React, { useState } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Topbar from '../../layouts/Topbar'
import Sidebar from '../../layouts/Sidebar'
import apiConfig, { API_BASE_URL as NAMED_API_BASE_URL } from '../../../config/api'

const API_BASE_URL = typeof apiConfig === 'string' ? apiConfig : NAMED_API_BASE_URL || 'https://pms.burrayhr.com'

const CreateCostCenter = () => {
  const navigate = useNavigate()
  const [costCenterName, setCostCenterName] = useState('')
  const [loading, setLoading] = useState(false)
  const baseUrl = API_BASE_URL

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const token = Cookies.get('token')
      
      if (!token) {
        toast.error('Authentication token not found. Please login again.')
        return
      }

      await axios.post(`${baseUrl}/api/course-centers/`, {
        name: costCenterName.trim()
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Cost Center added successfully!')
      setCostCenterName('')
      setTimeout(() => navigate('/hr/cost-centers'), 1200)

    } catch (err) {
      console.error('Error adding cost center:', err)
      const errorMessage = err.response?.data?.message || err.response?.data?.detail || 'Failed to add cost center. Please try again.'
      toast.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={3500} hideProgressBar={false} />
      <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
        <Topbar />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content pb-0">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
              <div>
                <h4 className="fw-bold mb-1">Add New Cost Center</h4>
                <p className="text-muted mb-0 fs-13">Create a new cost center for your organisation</p>
              </div>
              <Link to="/hr/cost-centers" className="btn btn-light">
                <i className="ti ti-arrow-left me-1" />
                Back to Cost Centers
              </Link>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5 className="fw-bold mb-0">Cost Center Details</h5>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="costCenterName" className="form-label">
                        Cost Center Name <span className="text-danger">*</span>
                      </label>
                      <input
                        id="costCenterName"
                        type="text"
                        className="form-control"
                        placeholder="Enter cost center name"
                        value={costCenterName}
                        onChange={(e) => setCostCenterName(e.target.value)}
                        required
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-end gap-2 mb-4">
                <Link to="/hr/cost-centers" className="btn btn-light" onClick={(e) => loading && e.preventDefault()}>
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !costCenterName.trim()}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Creating Cost Center...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-device-floppy me-1" />
                      Create Cost Center
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          <div className="footer d-flex align-items-center justify-content-between flex-column flex-sm-row row-gap-2 border-top py-2 px-3">
            <p className="text-dark mb-0">
              2026 © <span className="link-primary">Casoe Technologies</span>, All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateCostCenter